import React, { useCallback, useEffect, useRef, useState } from 'react';
import style from './index.scss';
import { DetailsStatusBadge } from '../../common/DetailsStatusBadge';
import { Icon } from 'js/components/common/Icon';
import { BannerProgressCircle } from '../../common/BannerProgressCircle';
import { leaderboardImage } from '../../common/DiscoveryItemWidgetMedia/leaderboardImage';
import { rocket } from '../../common/DiscoveryItemWidgetMedia/missionImage';

export default ({ imageUrl, visible, fakeState, translatedState, isMissions, eventCount, eventCountLimit }) => {
    let classes = [style.mediaContainer];
    const [imageWidth, setImageWidth] = useState(100);
    const imageWrapperRef = useRef();
    const imageRef = useRef();
    const minHeight = 164;
    const maxWidth = useRef(718);
    const [isLoadBannerFailed, setIsLoadBannerFailed] = useState(false);

    const calculateImageSize = useCallback(() => {
        if (imageWrapperRef && imageWrapperRef.current && imageWrapperRef.current.offsetWidth < 718) {
            maxWidth.current = imageWrapperRef.current.offsetWidth;
        }
        calculateImageWidth(imageRef.current.offsetHeight, imageRef.current.offsetWidth);
    }, []);

    const calculateImageWidth = (height, width) => {
        const renderedRatio = maxWidth.current / width;
        const renderedHeight = height * renderedRatio;
        const ratio = maxWidth.current / renderedHeight;
        const heightDiff = minHeight - renderedHeight;
        const widthDiff = heightDiff * ratio;
        const resultWidth = (maxWidth.current + widthDiff) * 100 / maxWidth.current;
        setImageWidth(Math.ceil(resultWidth <= 100 ? 100 : resultWidth));
    };

    const calculateImageSizeOnRotate = useCallback(() => {
        setImageWidth(100);
        setTimeout(() => {
            calculateImageSize();
        }, 300);
    }, [calculateImageSize]);

    useEffect(() => {
        const img = new Image();
        img.src = imageUrl;
        img.onload = function() {
            calculateImageSize();
        };
        img.onerror = function() {
            setIsLoadBannerFailed(true);
            setTimeout(() => {
                calculateImageSize();
            }, 200);
        };
        window.addEventListener('resize', calculateImageSizeOnRotate);
        return () => {
            window.removeEventListener('resize', calculateImageSizeOnRotate);
        };
    }, [calculateImageSize, calculateImageSizeOnRotate, imageUrl]);

    const defineDefaultBanner = () => {
        if (isLoadBannerFailed) {
           return isMissions ? rocket : leaderboardImage;
        }
        return imageUrl;
    };

    if (!visible) {
        classes.push(style.hidden);
    }
    classes = classes.join(' ');
    return (
        <div ref={imageWrapperRef} className={classes}>
            <img ref={imageRef} className={style.wrapper} src={defineDefaultBanner()} style={{
                width: `${imageWidth}%`
            }}>
            </img>
            <DetailsStatusBadge translatedState={translatedState} status={fakeState} className={style.startStatus}/>
            {isMissions && <div className={style.widgetIconWrapper}>
                <BannerProgressCircle style={style.progressCircle} withProgress={false} size={65} strokeWidth={5}
                                      percentage={eventCount * 100 / eventCountLimit} color="#fff" state={{}}
                                      isInMedia={true}/>
                <Icon className={style.iconStyle} type="missionsRocketDetailsBanner" />
                </div>}
        </div>
    );
};
